import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IEnum from '../../interfaces/IEnum'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { paymentModelList } from '../../services/api'

interface PaymentModelContextState extends BaseContextState {
  paymentModels: Array<IEnum> | null
}

interface PaymentModelContextData extends PaymentModelContextState {
  resetErrors: Function,
  requestPaymentModelList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as PaymentModelContextData)

// Export consumer
export const PaymentModelConsumer = Consumer

export class PaymentModelProvider extends BaseContextProvider {
  state: PaymentModelContextState = {
    paymentModels: null
  }

  /**
   * Make api request for payment models list
   * 
   * @param {SearchRequest} payload 
   */
  requestPaymentModelList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await paymentModelList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'paymentModels'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestPaymentModelList: this.requestPaymentModelList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
